// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"d86e6853","267":"41e1ae2c","442":"4f1e177b","446":"0a441dbe","488":"23a897dd"}[chunkId] + ".chunk.js";
};